import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

export interface PremiumServiceBottomSheetData {
  onConfirm: () => void;
}

@Component({
  selector: 'app-premium-service-bottomsheet',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './premium-service-bottomsheet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PremiumServiceBottomSheetComponent {
  readonly benefits = [
    { id: 'doctor', icon: '/assets/images/premium-service/doctor-video-call.svg', colorClass: 'tw-bg-blue-400' },
    { id: 'nutritionist', icon: '/assets/images/premium-service/nutritionist-calls.svg', colorClass: 'tw-bg-green-400' },
    { id: 'priority', icon: '/assets/images/premium-service/priority-support.svg', colorClass: 'tw-bg-teal-400' },
    { id: 'cash', icon: '/assets/images/premium-service/cure-cash.png', colorClass: 'tw-bg-gray-200' },
    { id: 'perks', icon: '/assets/images/premium-service/premium-perks.svg', colorClass: 'tw-bg-orange-400' },
  ];

  constructor(
    private readonly bottomSheetRef: MatBottomSheetRef<PremiumServiceBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) readonly data: PremiumServiceBottomSheetData,
  ) {}

  close(): void {
    this.bottomSheetRef.dismiss();
  }

  confirm(): void {
    this.data.onConfirm();
    this.bottomSheetRef.dismiss({ action: 'add' });
  }
}
